import { useState, useEffect } from "react";

export const useCalculateListSizeForPaginationHook = (height = 70) => {
	const [pageSize, setPageSize] = useState(10);
	const [windowWidth, setWindowWidth] = useState(window.innerHeight); // Añadimos un estado para innerWidth

	useEffect(() => {
		function calculateListSize() {
			const windowHeight = window.innerHeight;

			// Calcular el factor de zoom usando windowWidth (estado)
			const zoomFactor = window.outerHeight / windowWidth;

			const numElements = Math.floor((windowHeight -450) / (height*zoomFactor));
			if (numElements === 0) {
				setPageSize(10);
				return;
			}
			setPageSize(numElements);
		}

		// Función para verificar cambios en el tamaño o zoom
		function checkWindowWidth() {
			const currentWidth = window.innerHeight;
			if (currentWidth !== windowWidth) {
				setWindowWidth(currentWidth); // Actualizamos el valor de windowWidth
			}
		}

		// Configurar intervalo para verificar el zoom
		const interval = setInterval(checkWindowWidth, 500); // Verificamos cada 500ms

		// Ejecutar el cálculo de tamaño de lista al montar el componente
		calculateListSize();

		return () => {
			clearInterval(interval); // Limpiar el intervalo al desmontar el componente
		};
	}, [windowWidth]); // useEffect depende de windowWidth

	return {
		pageSize
	};
};

export const useCalculateWindowSizeForTextLength = (windowToReduce = 1100) => {
	const [textLength, settextLength] = useState(70);
	const [windowWidth, setWindowWidth] = useState(window.innerWidth); // Añadimos un estado para innerWidth

	useEffect(() => {
		function calculateTextLength() {
			const windowHeight = window.innerWidth;

			// Calcular el factor de zoom usando windowWidth (estado)
			const zoomFactor = window.outerWidth / windowWidth;

			const numElements = Math.max(
				5,  // Valor mínimo
				Math.floor((((windowHeight - windowToReduce) + 1) / (zoomFactor)) / (9 * zoomFactor) + 1)
			);
			
			if (numElements === 0) {
				settextLength(10);
				return;
			}
			settextLength(numElements);
		}

		// Función para verificar cambios en el tamaño o zoom
		function checkWindowWidth() {
			const currentWidth = window.innerWidth;
			if (currentWidth !== windowWidth) {
				setWindowWidth(currentWidth); // Actualizamos el valor de windowWidth
			}
		}

		// Configurar intervalo para verificar el zoom
		const interval = setInterval(checkWindowWidth, 500); // Verificamos cada 500ms

		// Ejecutar el cálculo de tamaño de lista al montar el componente
		calculateTextLength();

		return () => {
			clearInterval(interval); // Limpiar el intervalo al desmontar el componente
		};
	}, [windowWidth]); // useEffect depende de windowWidth

	return {
		textLength
	};
};
